import BaseComponent from 'scripts/BaseComponent.js';
import UnderlayHelper from '../../global/underlay-helper';
import { AccessibilityHelper } from '../../../scripts/accessibility/accessibilityHelper';

export default class SearchDrawer extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      searchToggleBtn: '.js-searchToggleBtn',
      searchInput: '.js-searchInput',
    };

    this.dom = {
      $component: component,
      $searchToggleBtns: document.querySelectorAll(this.refs.searchToggleBtn),
      $searchInput: this.$get(this.refs.searchInput),
    };

    this.state = {
      searchOpen: false,
      searchOpenClass: 'open-search',
      underlayHelper: new UnderlayHelper({ overNav: true }),
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
      desktopBreakpoint: '(min-width: 1024px)',
      closeSearchEvent: 'closesearchdrawer',
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.setClick(Array.from(dom.$searchToggleBtns), this.toggleSearch);
    state.underlayHelper.addClickListener(this.closeSearch.bind(this));
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
    this.setOnCustomEvent(state.closeSearchEvent, this.closeSearch);
  }

  toggleSearch() {
    const { state } = this;

    if (state.searchOpen) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  isDesktop() {
    const { state: { desktopBreakpoint } } = this;
    return window.matchMedia(desktopBreakpoint).matches;
  }

  openSearch() {
    const { dom, state } = this;

    dom.$component.classList.add(state.searchOpenClass);
    dom.$component.setAttribute('aria-hidden', 'false');
    dom.$component.setAttribute('aria-expanded', 'true');
    state.focusTrap.set();

    if (this.isDesktop()) {
      state.underlayHelper.open();
    }

    dom.$searchInput.focus();
    state.searchOpen = true;
  }

  closeSearch() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.searchOpenClass);
    dom.$component.setAttribute('aria-hidden', 'true');
    dom.$component.setAttribute('aria-expanded', 'false');
    state.focusTrap.unset();

    if (this.isDesktop()) {
      state.underlayHelper.close();
    }

    state.searchOpen = false;
  }
}
